export default __webpack_public_path__ + "static/media/gallery-wip-preparations_00.a2762a9b.jpg";